// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__1VpSj","title":"AfterImages45_title__190FJ","images":"AfterImages45_images__-qqnX"};